import styled from 'styled-components';

export const MenubarContent = styled.div<{
  $isOpen?: boolean;
  $bottom?: boolean;
  $right?: boolean;
}>`
  z-index: 1;
  position: absolute;
  padding: 5px;

  ${({ $bottom }) => $bottom && 'bottom: 0; transform: translateY(100%);'}
  ${({ $right }) => $right && 'top: -6px; right: 0; transform: translateX(100%);'}

  display: flex;
  flex-direction: column;

  background-color: var(--neutral-2);
  border: 1px solid var(--neutral-3);
  border-radius: var(--radius-2);

  box-shadow: var(--shadow-1);

  opacity: 0;
  pointer-events: none;
  transition: opacity var(--transition-2);
  ${({ $isOpen }) => $isOpen && 'opacity: 1; pointer-events: all;'}
`;
